<template>
  <b-container fluid>
    <b-row no-gutters>
     <b-col md="2" lg="1" order-lg="5" order-md="3" class="text-right"
        v-if="cycle.canChangeEndDate"
      >
        <b-button class="btn btn-success edit-cycle" @click.prevent="editCycle">
          <font-awesome-icon icon="pencil-alt" size="xs"></font-awesome-icon>
        </b-button>
        <b-button class="btn btn-danger delete-cycle" @click.prevent="deleteCycle">
          <font-awesome-icon icon="trash-alt" size="xs"></font-awesome-icon>
        </b-button>
      </b-col>
     <b-col md="5" lg="3" order-lg="1" order-md="1">
        <span class="label">Data rozpoczęcia makrocyklu</span>
        <span class="value">{{cycle.startDate | date}}</span>
      </b-col>
     <b-col md="5" lg="3" order-lg="2" order-md="2">
        <span class="label">Data zakończenia makrocyklu</span>
        <span class="value">{{cycle.endDate| date}}</span>
      </b-col>
    <b-col md="5" lg="3" order-lg="3" order-md="4">
        <span class="label">Dzień wolny</span>
        <span class="value">{{cycle.freeDay| freeDay}}</span>
      </b-col>
    <b-col md="5" lg="2" order-lg="4" order-md="5">
        <span class="label">Typ makrocyklu</span>
        <span class="value">{{cycle.type| cycleType}}</span>
      </b-col>
    </b-row>

  </b-container>
</template>

<style lang="scss" scoped>
// .bordered-box {
//   border: 1px solid rgba(0, 0, 0, 0.125);
//   border-radius: 5px;
//   padding: 7px;
//   margin: 3px;
//   background: rgba(0, 0, 0, 0.03);
// }
.container-fluid {
  padding: 0px;
}
.label {
  font-weight: 600;
}
.value {
  font-style: italic;
  display: block;
  margin-bottom: 10px;
}
.edit-cycle {
  padding: 3px 10px;
  margin-bottom: 5px;
    margin-right:10px;
}
.delete-cycle {
  padding: 3px 10px;
  margin-bottom: 5px;
}
</style>
<script>
import moment from "moment";
export default {
  props: ["cycle"],
  data() {
    return {};
  },
  methods: {
    moment() {
      return moment();
    },
    editCycle() {
      this.$emit("edit");
    },
    deleteCycle() {
      this.$emit("delete");
    }
    
  },
  filters: {
    date(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "-";
    },
    freeDay(value) {
      if (value === 1) return "Poniedziałek";
      if (value === 2) return "Wtorek";
      if (value === 3) return "Środa";
      if (value === 4) return "Czwartek";
      if (value === 5) return "Piątek";
      if (value === 6) return "Sobota";

      return "-";
    },
     cycleType(value){
      return  value == 0 ? 'Standard' : 
              value == 1 ? 'Same rozmowy' : 
              null;
    }
  }
};
</script>
